<template>
  <div class="Container">
    <div class="Half First" />
    <div class="Half Second" />
  </div>
</template>

<script>
export default {
  name: 'PartialChip'
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.Container {
  height: 30px;
  width: 30px;
  border-radius: 15px;
  overflow: hidden;
  position: relative;

  .Half {
    height: 40px;
    width: 40px;
    position: absolute;
    transform: rotate(45deg);
  }

  .First {
    top: -20px;
    left: -20px;
    background-color: $secondary;
  }

  .Second {
    bottom: -20px;
    right: -20px;
    background-color: yellow;
  }
}
</style>
